// The office app as a ui-web view's host (packages/ui-web host.ts): a view's tool call goes through the
// app's own client, as the person, and opening a place is the app's own navigation (App.tsx).
import { RpcError } from '@flowology/client';
import type { Host, OpenTarget, ToolAnswer } from '@flowology/ui-web';
import { client } from '../api.ts';
import { shownTheme } from './theme.ts';

export function officeHost(open: (t: OpenTarget) => void): Host {
  return {
    surface: 'office',
    // the person's light or dark (BL-135), the device's unless they picked one
    theme: shownTheme(),
    open,
    async callTool(name, args): Promise<ToolAnswer> {
      try {
        return { ok: true, result: await client.call(name, args) };
      } catch (e) {
        if (!(e instanceof RpcError))
          return { ok: false, code: 'error', message: 'That did not work. Try again.' };
        // an action that needs a person's tap waits for it (DEC-009); the view says so
        if (e.code === 'pending_approval') {
          const approvalId = (e.detail as { approvalId?: unknown } | undefined)?.approvalId;
          return {
            ok: false,
            waiting: true,
            message: e.message,
            ...(typeof approvalId === 'string' ? { approvalId } : {}),
          };
        }
        return { ok: false, code: e.code, message: e.message };
      }
    },
  };
}
